document.addEventListener('change', function(event) {
  if (!event.target.matches('[data-variant-select]')) return;
  const select = event.target;
  const option = select.options[select.selectedIndex];
  const info = select.closest('.product-info');
  info.querySelector('[data-product-price]').textContent = option.dataset.price;
  const button = info.querySelector('[data-add-to-cart]');
  const available = option.dataset.available === 'true';
  button.disabled = !available;
  button.textContent = available ? 'In winkelmandje' : 'Tijdelijk uitverkocht';
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
});
document.addEventListener('click', function(event) {
  const link = event.target.closest('.mobile-menu a');
  if (link) link.closest('details').open = false;
});
